import * as config from '@/config/config.json';

export const PRIVATE_BSD_LABEL = {
  PurchasePrice: 'Purchase Price',
  PurchaserType: 'Purchaser Type',
  ProfileStatus: 'Profile Status',
  Residency: 'Residency',
  NumberOfExistingProperties: 'Number of Existing Properties',
  BreakdownOfStampDuty: 'Breakdown of Stamp Duty',
  TotalStampDuty: 'Total Stamp Duty',
  BSD: `Buyer's Stamp Duty (BSD)`,
  ABSD: `Additional Buyer's Stamp Duty (ABSD)`,
  PlusAddProfile: 'Add Profile',
  AdditionalProfile: 'Additional Profile',
  PurchaseDetails: 'Purchase Details',
};

export enum PurchaserType {
  Individual = 'individual',
  EntityOrTrust = 'entityOrTrust',
}

export const PurchaserTypeName: Record<PurchaserType, string> = {
  [PurchaserType.Individual]: 'Individual',
  [PurchaserType.EntityOrTrust]: 'Entity / Trust',
};

export enum ProfileStatus {
  Single = 'single',
  Married = 'married',
  Joint = 'joint',
}

export enum NumberOfExistingProperties {
  NoProperty = '0',
  OneProperty = '1',
  TwoPropertyAndMore = '2',
}

export enum Residency {
  Citizen = 'citizen',
  PermanentResidence = 'pr',
  Foreigner = 'foreigner',
}

export const ResidencyName: Record<Residency, string> = {
  [Residency.Citizen]: 'SG Citizen',
  [Residency.PermanentResidence]: 'PR',
  [Residency.Foreigner]: 'Foreigner',
};

/*
  Stamp duty percentages for various calculations based on the number of existing properties on the ABSD sheet.:
  - 'citizen': 0%, 20%, 30%
  - 'pr': 5%, 30%, 35%
  - 'foreigner': 60%, 60%, 60%
  - 'entityOrTrust': 65%, 65%, 65%
https://hersingaxiom.sharepoint.com/:x:/r/sites/ERAInnovationTeam/_layouts/15/Doc.aspx?sourcedoc=%7B0C49D869-629C-408C-A608-91E3427EEDF3%7D&file=Private%20Resale%20Calculator.xlsx&action=default&mobileredirect=true
 */

export const BUYER_STAMP_DUTY_CALCULATOR: Record<Residency, { 0: number; 1: number; 2: number }> = {
  [Residency.Citizen]: {
    0: config.absd_in_percent.sc.buying_first_property,
    1: config.absd_in_percent.sc.buying_second_property,
    2: config.absd_in_percent.sc.buying_third_property,
  },
  [Residency.PermanentResidence]: {
    0: config.absd_in_percent.pr.buying_first_property,
    1: config.absd_in_percent.pr.buying_second_property,
    2: config.absd_in_percent.pr.buying_third_property,
  },
  [Residency.Foreigner]: {
    0: config.absd_in_percent.foreigners.buying_first_property,
    1: config.absd_in_percent.foreigners.buying_second_property,
    2: config.absd_in_percent.foreigners.buying_third_property,
  },
};

export const RATE_ENTITY_TRUST = config.absd_in_percent.entities;

export const PURCHASER_TYPE = {
  LIST: Object.values(PurchaserType).map((type) => {
    return {
      value: type,
      label: PurchaserTypeName[type],
    };
  }),
};

export const PROFILE_STATUS = {
  LIST: Object.entries(ProfileStatus).map(([key, value]) => {
    return {
      value,
      label: key,
    };
  }),
};

export const RESIDENCY = {
  LIST: Object.values(Residency).map((residency) => {
    return {
      value: residency,
      label: ResidencyName[residency],
    };
  }),
};

export const NUMBER_EXISTING_PROPERTIES = {
  LIST: Object.values(NumberOfExistingProperties).map((value) => {
    return {
      value,
      label: value === NumberOfExistingProperties.TwoPropertyAndMore ? `${value}+` : value,
    };
  }),
};
